import { render, staticRenderFns } from "./CryptoAgeLimitModal.vue?vue&type=template&id=00aa102a&scoped=true"
import script from "./CryptoAgeLimitModal.vue?vue&type=script&lang=js"
export * from "./CryptoAgeLimitModal.vue?vue&type=script&lang=js"
import style0 from "./CryptoAgeLimitModal.vue?vue&type=style&index=0&id=00aa102a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00aa102a",
  null
  
)

export default component.exports